import { render } from "./languages.html?vue&type=template&id=74a39263&scoped=true&ts=true&external"
import script from "./languages.ts?vue&type=script&lang=ts&external"
export * from "./languages.ts?vue&type=script&lang=ts&external"

import "./languages.scss?vue&type=style&index=0&id=74a39263&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a39263"]])

export default __exports__